import { render, staticRenderFns } from "./GiveOut.vue?vue&type=template&id=19f56b4a&scoped=true"
import script from "./GiveOut.vue?vue&type=script&lang=js"
export * from "./GiveOut.vue?vue&type=script&lang=js"
import style0 from "./GiveOut.vue?vue&type=style&index=0&id=19f56b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f56b4a",
  null
  
)

export default component.exports